import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { formatMoney, formatNumber } from '../../common/helpers';
import { useUrlProps } from '../../common/urlProps';
import useFetch from '../../common/useFetch';
import TicketService from '../../domain/TicketService';
import gs from '../../styles/style';
import Breadcrumbs from '../Common/Breadcrumbs';
import DateTime from '../Common/DateTime';
import Loader from '../Common/Loader';
import TicketNumber from '../Tickets/TicketNumber';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
;
var Ticket = function (_a) {
    var match = _a.match;
    var t = useTranslation()[0];
    var _b = useFetch(function (config) { return TicketService.getTicket(match.params.ticket, config); }), ticket = _b.data, getTicket = _b.get;
    var urlProps = useUrlProps();
    useEffect(function () {
        getTicket();
    }, []);
    if (!ticket) {
        return React.createElement(Loader, null);
    }
    return React.createElement("div", null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/tickets" }, t('tickets'))),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') },
                React.createElement(TicketNumber, { number: ticket.number }))),
        React.createElement("div", { className: gs('row', 'mb-4') },
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h2", null, formatNumber(ticket.active_participations_count)),
                t('draws')),
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h2", null, formatNumber(ticket.won_prizes.length)),
                t('won_prizes')),
            React.createElement("div", { className: gs('col-md-3') },
                React.createElement("h2", null, formatMoney(ticket.winnings)),
                t('winnings'))),
        React.createElement("div", { className: gs('card-group', 'mb-4') },
            React.createElement("div", { className: gs('card') },
                React.createElement("div", { className: gs('card-body') },
                    React.createElement("table", { className: gs('table', 'table-borderless', 'table-sm', 'mb-0') },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { style: { width: '30%' } },
                                    React.createElement("strong", null, t('customer'))),
                                React.createElement("td", null,
                                    ticket.customer.name,
                                    ' ',
                                    ticket.customer.verified_at && React.createElement("small", { className: gs('text-success') },
                                        React.createElement(FontAwesomeIcon, { icon: "check" })))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("strong", null, t('payout_iban'))),
                                React.createElement("td", null, ticket.customer.payout_iban || React.createElement("span", { className: gs('text-danger') }, t('unknown')))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("strong", null, t('created_at'))),
                                React.createElement("td", null,
                                    React.createElement(DateTime, { date: ticket.created_at }))))))),
            React.createElement("div", { className: gs('card') },
                React.createElement("div", { className: gs('card-body') },
                    React.createElement("table", { className: gs('table', 'table-borderless', 'table-sm', 'mb-0') },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { style: { width: '30%' } },
                                    React.createElement("strong", null, t('source'))),
                                React.createElement("td", null, ticket.customer.rsu && ticket.customer.rsu.title)),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("strong", null, t('external_customer_id'))),
                                React.createElement("td", null,
                                    ticket.customer.external_id && React.createElement("code", null, ticket.customer.external_id),
                                    !ticket.customer.external_id && React.createElement("span", { className: gs('text-muted') }, "\u2013"))),
                            React.createElement("tr", null,
                                React.createElement("td", null,
                                    React.createElement("strong", null, t('external_ticket_id'))),
                                React.createElement("td", null,
                                    ticket.external_id && React.createElement("code", null, ticket.external_id),
                                    !ticket.external_id && React.createElement("span", { className: gs('text-muted') }, "\u2013")))))))),
        React.createElement("ul", { className: gs('nav', 'nav-tabs', 'mb-4') },
            React.createElement("li", { className: gs('nav-item') },
                React.createElement(Link, { to: urlProps.mergeLink({ tab: null }), className: gs('nav-link', { active: !urlProps.get('tab') }) }, t('draws'))),
            React.createElement("li", { className: gs('nav-item') },
                React.createElement(Link, { to: urlProps.mergeLink({ tab: 'payments' }), className: gs('nav-link', { active: urlProps.get('tab') == 'payments' }) }, t('payments')))),
        !urlProps.get('tab') && React.createElement(DrawsTable, { ticket: ticket }),
        urlProps.get('tab') == 'payments' && React.createElement(PaymentsTable, { ticket: ticket }));
};
var DrawsTable = function (_a) {
    var ticket = _a.ticket;
    var t = useTranslation()[0];
    return (React.createElement("table", { className: gs('table-overview') },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { style: { width: '25%' } }, t('draw')),
                React.createElement("th", { style: { width: '25%' } }, t('prize')),
                React.createElement("th", { style: { width: '12.5%' } }, t('unit_price')),
                React.createElement("th", { style: { width: '12.5%' } }, t('selling_price')),
                React.createElement("th", { style: { width: '15%' } }, t('external_payment_id')),
                React.createElement("th", { style: { width: '10%' } }, t('active')))),
        React.createElement("tbody", null, ticket.participations.map(function (participation) { return React.createElement("tr", { key: participation.id },
            React.createElement("td", null,
                React.createElement(Link, { to: "/draws/".concat(participation.draw.id) },
                    React.createElement("strong", null, participation.draw.title))),
            React.createElement("td", null,
                participation.verified_won_prizes.map(function (wonPrize, i) { return React.createElement(Fragment, { key: wonPrize.id },
                    wonPrize.prize.title,
                    React.createElement("small", { className: gs('text-muted') },
                        ' / ',
                        formatMoney(wonPrize.amount),
                        wonPrize.prize.prize_distributor_id && (React.createElement(Fragment, null,
                            ' / ',
                            wonPrize.prize_distribution ? React.createElement(Link, { to: "/prize-distributors/".concat(wonPrize.prize_distribution.prize_distributor_id, "/prize-distributions/").concat(wonPrize.prize_distribution.id) },
                                t('distributed'),
                                " ",
                                React.createElement(DateTime, { date: wonPrize.prize_distribution.created_at })) : React.createElement("span", { className: gs('text-muted') }, t('undistributed'))))),
                    i < participation.verified_won_prizes.length - 1 && ', '); }),
                participation.verified_won_prizes.length == 0 && React.createElement("span", { className: gs('text-muted') }, "\u2013")),
            React.createElement("td", null, formatMoney(participation.unit_price)),
            React.createElement("td", null, formatMoney(participation.selling_price)),
            React.createElement("td", null,
                participation.payment && React.createElement("code", null, participation.payment.external_id),
                !participation.payment && React.createElement("span", { className: gs('text-muted') }, "\u2013")),
            React.createElement("td", null,
                React.createElement("small", { className: gs(participation.active ? 'text-success' : 'text-danger') },
                    React.createElement(FontAwesomeIcon, { icon: participation.active ? 'check' : 'times' })))); }))));
};
var PaymentsTable = function (_a) {
    var ticket = _a.ticket;
    var t = useTranslation()[0];
    return (React.createElement("table", { className: gs('table-overview') },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { style: { width: '25%' } }, t('external_id')),
                React.createElement("th", { style: { width: '25%' } }, t('amount')),
                React.createElement("th", { style: { width: '25%' } }, t('status')),
                React.createElement("th", { style: { width: '25%' } }, t('paid_at')))),
        React.createElement("tbody", null, ticket.payments.map(function (payment) { return React.createElement("tr", { key: payment.id },
            React.createElement("td", null,
                payment.external_id && React.createElement("code", null, payment.external_id),
                !payment.external_id && React.createElement("span", { className: gs('text-muted') }, "\u2013")),
            React.createElement("td", null, formatMoney(payment.amount)),
            React.createElement("td", null, t("payment_statuses:".concat(payment.status))),
            React.createElement("td", null,
                React.createElement(DateTime, { date: payment.paid_at }))); }))));
};
export default withRouter(Ticket);
